import './App.css';

import Routers from './routers';
import {store,persistor} from './store';
import { Provider } from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';


// estilos
import { ThemeProvider } from '@mui/material/styles';
import theme from './assets/css/theme';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { getToken } from './helpers';
import { apiEmpresa } from './services/apiEmpresa';
import { apiProfissional } from './services/apiProfissional';
import { apiFiles } from './services/apiFiles';
import { expirarSessao } from './store/actions/AutenticacaoActions';
import {interceptor} from './interceptor';


function App() {
  

  const manutencao = false;

  if (manutencao) {
    return (
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            px: 2,
          }}
        >
          <Box>
            <Typography variant="h3" color="primary" gutterBottom>
              Em manutenção
            </Typography>

            <Typography variant="h6" color="text.secondary">
              Estamos realizando ajustes no sistema.
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
              Tente novamente mais tarde.
            </Typography>
          </Box>
        </Box>
      </ThemeProvider>
    );
  }

const interceptorHTTP = interceptor();

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate
            loading={<CircularProgress color="primary" />}
            persistor={persistor}
          >
            <Routers />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;